import { MerchantsOnboardingApiBase } from './paymentApi';

class MerchantOnboardingApi extends MerchantsOnboardingApiBase {

}

export default new MerchantOnboardingApi();
